import {
    GetStudentList,
    DeleteStudent,
    ChangeStudentStatus,
    PostStudent,
    GetStudent,
    UpdateStudent,
    GetStudentTimeline,
} from '@src/services/student'
import { GetResponsibleList, GetResponsible } from '@src/services/responsible'
import { getSavedState } from '@src/utils/localStorage'
export const state = {
    studentList: [],
    responsibleList: [],
    responsibleFromForm: '',
    timeline: [],
}

export const getters = {
    totalList(state) {
        return state.studentList.data
            ? state.studentList.data.list.totalItemCount
            : 0
    },
    maxStudent(state) {
        return state.studentList.data ? state.studentList.data.max : 0
    },
    currentStudent(state) {
        return state.studentList.data ? state.studentList.data.current : 0
    },
}

export const mutations = {
    SET_LIST(state, newList) {
        state.studentList = newList
    },
    SET_RESPONSIBLE_LIST(state, newList) {
        state.responsibleList = newList
    },
    NEXT_PAGE_LIST(state, list) {
        list.forEach((student) => {
            state.studentList.data.list.items.push(student)
        })
    },
    SET_STATUS(state, student) {
        state.studentList.data.list.items.find(({ publicId }) => {
            return publicId === student.publicId
        }).status = student.status
    },
    SET_RESPONSIBLE(state, responsible) {
        state.responsibleFromForm = responsible
    },
    SET_STUDENT_TIMELINE(state, timeline) {
        state.timeline = timeline
    },
}

export const actions = {
    async fetchList({ commit }, parameters = {}) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetStudentList(locationPublicId, parameters)
        if (resp.status === 200) {
            commit('SET_LIST', resp.data)
        }
    },
    async getResponsiblesList({ commit }, parameters) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetResponsibleList(locationPublicId, parameters)
        if (resp.status === 200) {
            commit('SET_RESPONSIBLE_LIST', resp.data.data.items)
        }
    },
    async nextPage({ commit }, currentPage) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetStudentList(locationPublicId, currentPage)
        if (resp.status === 200) {
            commit('NEXT_PAGE_LIST', resp.data.data.list.items)
        }
    },
    async deleteStudent({ dispatch }, student) {
        const resp = await DeleteStudent(student)
        if (resp.status === 200) {
            dispatch('fetchList')
        }
        return resp
    },
    async setStatus({ commit, dispatch }, parameters) {
        const resp = await ChangeStudentStatus(parameters)
        if (resp.status === 200) {
            commit('SET_STATUS', parameters)
        }
        return resp
    },
    async createStudent({ _ }, studentMember) {
        studentMember.locationPublicId = getSavedState(
            'auth.selectedLocation'
        ).publicId
        const resp = await PostStudent(studentMember)
        return resp
    },
    async setStudentForm({ dispatch }, student) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetStudent(student, locationPublicId)
        // dispatch('setStudentTimeline', { student, locationPublicId })
        return resp
    },
    async setStudentTimeline({ commit }, { student, locationPublicId }) {
        const resp = await GetStudentTimeline(student, locationPublicId)
        commit('SET_STUDENT_TIMELINE', resp.data.data)
        return resp
    },
    async updateStudent({ _ }, student) {
        student.locationPublicId = getSavedState(
            'auth.selectedLocation'
        ).publicId
        const resp = await UpdateStudent(student)
        return resp
    },
    async changeStudentStatus({ _ }, student) {
        student.locationPublicId = getSavedState(
            'auth.selectedLocation'
        ).publicId
        const resp = await ChangeStudentStatus(student)
        return resp
    },
    async setResponsibleFromStudent({ commit }, responsible) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetResponsible(responsible, locationPublicId)
        commit('SET_RESPONSIBLE', resp.data.data)
        return resp
    },
    removeResponsbileFromForm({ commit }) {
        commit('SET_RESPONSIBLE', null)
    },
}
